import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Users02 } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_profile")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("profile", context.tenant.modules);

    return {
      title: () => context.t("Profile", { ns: "profile.shared" }),
      crumb: [
        {
          Icon: Users02,
        },
        {
          label: context.t("Profile", { ns: "profile.shared" }),
          link: { to: "/admin/profile" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
